import Tooltip from "@/v2-ui/tooltip"
import { DotText } from "@/v2-backoffice-client/components/dot"
import type { UserActivityFragment } from "@/v2-backoffice-client/user/activity/__types__/user.activity.fragment"
import { getUserActivityLevelVariant } from "@/v2-backoffice-client/user/activity/userActivity.constants"

export type UserActivityBadgeProps = {
  level: UserActivityFragment
}

function UserActivityBadge(props: UserActivityBadgeProps) {
  const { level } = props
  const variant = getUserActivityLevelVariant(level.Code)

  return (
    <Tooltip>
      <Tooltip.Trigger asChild>
        <DotText variant={variant}>{level.Name}</DotText>
      </Tooltip.Trigger>

      <Tooltip.Content
        side="top"
        className="ui-tooltip-content--panel text-muted-foreground"
      >
        <div className="flex flex-col gap-0.5 p-3">
          <DotText
            variant={variant}
            className="font-medium text-popover-foreground flex"
          >
            {level.Name}
          </DotText>

          {level.Description}
        </div>
      </Tooltip.Content>
    </Tooltip>
  )
}

export default UserActivityBadge
